import type { RefOrGetter } from "ls/common/types";
import { useQuery } from "@tanstack/vue-query";
import { useLocationParts } from "ls/composables/useLocationParts";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useFileLocation(shortcut: RefOrGetter<string | undefined>) {
  const options = computed(() => queries.location(toValue(shortcut)));
  const { data: location } = useQuery(options);

  return useLocationParts(location);
}
